(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" ng-show="$ctrl.isDialogAlert || (!$ctrl.isDialogAlert && !$ctrl.isDialogOpen())">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('superChannelApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', '$rootScope', 'AlertService'];

    function jhiAlertController($scope, $rootScope, AlertService) {
        var vm = this;

        vm.isDialogOpen = isDialogOpen;
        function isDialogOpen() {
            return $rootScope.dialogOpen;
        }
        vm.isDialogAlert = $rootScope.dialogOpen ? true : false;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
